import api from "../../../lib/axios";
import type { BaseResponse } from "../../../lib/api-contract";
import type {
  WalletTransaction,
  WalletTransactionPage,
  WalletTransactionSummary,
} from "../types/walletTransactions.types";
interface RawItem {
  id: string;
  user_id: string;
  user_name: string;
  user_email: string;
  type: string;
  amount: number;
  status: string;
  source_type: string;
  source_id: string;
  description: string;
  external_reference?: string;
  created_at: string;
}
interface RawData {
  summary?: {
    total_transactions: number;
    completed_transactions: number;
    pending_transactions: number;
    failed_transactions: number;
    credit_points: number;
    debit_points: number;
  };
  list?: RawItem[];
  paging?: { count?: number; total?: number };
}
const unwrap = <T>(value: BaseResponse<T>): T => (value.data ?? {}) as T;
export async function getWalletTransactions(
  params: Record<string, string | number>,
  signal?: AbortSignal,
): Promise<WalletTransactionPage> {
  const result = await api.get<BaseResponse<RawData>>("/v1/portal/wallet-transactions", {
    params,
    signal,
  });
  const data = unwrap(result.data);
  const summary: WalletTransactionSummary | null = data.summary
    ? {
        totalTransactions: data.summary.total_transactions,
        completedTransactions: data.summary.completed_transactions,
        pendingTransactions: data.summary.pending_transactions,
        failedTransactions: data.summary.failed_transactions,
        creditPoints: data.summary.credit_points,
        debitPoints: data.summary.debit_points,
      }
    : null;
  return {
    items: (data.list ?? []).map((item): WalletTransaction => ({
      id: item.id,
      userId: item.user_id,
      userName: item.user_name,
      userEmail: item.user_email,
      type: item.type,
      amount: item.amount,
      status: item.status,
      sourceType: item.source_type,
      sourceId: item.source_id,
      description: item.description,
      externalReference: item.external_reference,
      createdAt: item.created_at,
    })),
    totalCount: data.paging?.count ?? data.paging?.total ?? 0,
    summary,
  };
}
